import { useState } from "react"
import ContextProvider from "./context/ContextProvider";
import ScheduledPostTab from "./components/scheduled/ScheduledPostTab";
// import PendingPostTab from "./components/PendingPostTab";
// import { Signpost } from "lucide-react";
import {
  // useNavigate, useParams, 
  useSearchParams } from "react-router-dom";

export type PendingFilterType = {
  name: string;
  startDate: Date | undefined;
  endDate: Date | undefined;
  type: "Post" | "Campaign" | undefined;
  isFilter: boolean
}

// type RouteParams = {
  // id: string;
// }

const ApprovalView = () => {
  // const { id } = useParams<RouteParams>()
  const [searchParams, setSearchParams] = useSearchParams();
  const eventName = searchParams.get("event")
  // const [tab, setTab] = useState(id)
  // const navigate = useNavigate()
  // const [pendingFilter, setPendingFilter] = useState<PendingFilterType>({ name: eventName ? eventName : "", startDate: undefined, endDate: undefined, type: undefined, isFilter: false })
  const [scheduledFilter, setScheduledFilter] = useState(eventName ? eventName : "");

  // const onTabChange = (value: string) => {
  //   navigate(`/home/approve/${value}`)
  //   setTab(value)
  // }

  return (
    <ContextProvider>
      <div className="mt-[5vh] w-full h-[95vh] overflow-auto relative">
        <div className="flex justify-start items-center">
          <h1 className="font-header p-10 pb-3 tracking-wide 2xl:pt-10 text-xl lg:text-5xl font-[500]">Scheduled Lineup</h1>
        </div>
        <div className="w-full flex justify-center items-center px-5 md:px-10">
          <ScheduledPostTab filter={scheduledFilter} resetFilter={() => {
            setScheduledFilter("")
            setSearchParams({})
          }
          } />
        </div>
      </div>
    </ContextProvider>
  )
}

export default ApprovalView
